import { render, staticRenderFns } from "./WorkloadStats.vue?vue&type=template&id=f480b140&"
import script from "./WorkloadStats.vue?vue&type=script&lang=js&"
export * from "./WorkloadStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports